import { Globe, LayoutDashboard, Rss, Settings, ShieldCheck, Store } from '@lucide/vue'
import type { Component } from 'vue'
import { Permission, type PermissionKey } from '@/lib/permissions/keys'

export interface NavItem {
  titleKey: string
  icon: Component
  /** Omitted for items that open an external tool instead of an in-app page. */
  route?: string
  /** Opens the item in a new browser tab (via SSO redirect) rather than navigating in-app. */
  opensInNewTab?: boolean
  /** Backend permission needed to see the item; omitted until the backend defines one. */
  permission?: PermissionKey
  /** Shown only to system admins (Super Admin), see `AuthUser.isSystemAdmin`. */
  systemAdminOnly?: boolean
  /** Draws a horizontal divider above the item to start a new section. */
  separatorBefore?: boolean
}

/**
 * Configuration-driven sidebar navigation (§12). AppSidebar filters this
 * list by `systemAdminOnly` and `can(item.permission)` rather than hardcoding menu markup.
 *
 * Only merchants and websites have backend permissions so far; the other items stay visible until
 * the backend defines permissions for them.
 */
export const navigation: NavItem[] = [
  {
    titleKey: 'navigation.dashboard',
    icon: LayoutDashboard,
    route: '/dashboard',
  },
  {
    titleKey: 'navigation.merchants',
    icon: Store,
    route: '/merchants',
    permission: Permission.MerchantList,
  },
  {
    titleKey: 'navigation.websites',
    icon: Globe,
    route: '/websites',
    permission: Permission.WebsiteList,
  },
  {
    titleKey: 'navigation.feedTool',
    icon: Rss,
    opensInNewTab: true,
  },
  {
    titleKey: 'navigation.settings',
    icon: Settings,
    route: '/settings',
  },
  {
    titleKey: 'navigation.systemAdmin',
    icon: ShieldCheck,
    route: '/system-admin',
    systemAdminOnly: true,
    separatorBefore: true,
  },
]
